import React, { FC, memo, ReactElement, ReactNode } from 'react';
import { Container } from 'react-bootstrap';
import { NavigateFunction, useNavigate } from 'react-router';
import i18next from 'i18next';
import Button from 'react-bootstrap/Button';
import { ITherapy } from '../../../util/types';

type TherapyDetailsProps = {
  children: ReactNode;
  therapy: ITherapy;
};

function getPatientName(therapy: ITherapy): string {
  const firstName: string = therapy.patient?.firstName ?? therapy.firstName ?? '';
  const lastName: string = therapy.patient?.lastName ?? therapy.lastName ?? '';

  return `${firstName} ${lastName}`.trim();
}

const TherapyDetails: FC<TherapyDetailsProps> = ({ children, therapy }: TherapyDetailsProps): ReactElement => {
  const navigate: NavigateFunction = useNavigate();

  const patientName: string = getPatientName(therapy);
  const isActivated: boolean = Boolean(therapy.patient?.isEmailVerified);

  return (
    <div>
      <Container className="py-4">
        <div
          className="d-flex align-items-center justify-content-between gap-3 px-4 py-3 text-white rounded-3 mb-3"
          style={{ backgroundColor: '#234a68' }}
        >
          <Button
            variant="outline-light"
            className="d-inline-flex align-items-center gap-2 flex-shrink-0 text-nowrap"
            onClick={() => navigate(-1)}
            aria-label={i18next.t('generic.back')}
          >
            <i className="fas fa-angle-left" aria-hidden="true" />
            <span className="d-none d-sm-inline">{i18next.t('generic.back')}</span>
          </Button>

          <div className="d-flex align-items-center justify-content-end gap-3 text-truncate">
            <span className="fw-semibold fs-4 text-truncate">{patientName}</span>

            <span
              className="badge rounded-pill d-inline-flex align-items-center gap-2 flex-shrink-0 fw-semibold"
              style={{ backgroundColor: '#fff', color: '#234a68' }}
            >
              <i
                className="fas fa-circle"
                style={{ fontSize: '0.5rem', color: isActivated ? '#28a745' : '#e8b84b' }}
                aria-hidden="true"
              />
              {i18next.t(isActivated ? 'therapyDetails.status.activated' : 'therapyDetails.status.pending')}
            </span>
          </div>
        </div>

        {children}
      </Container>
    </div>
  );
};

export default memo(TherapyDetails);
